import { render, staticRenderFns } from "./Institutional.vue?vue&type=template&id=0aa5b001&"
import script from "./Institutional.vue?vue&type=script&lang=js&"
export * from "./Institutional.vue?vue&type=script&lang=js&"
import style0 from "./Institutional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports